/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const productReleaseLines = sqliteTable('product_release_lines', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  product_release_id: text('product_release_id'),
  invoice_item_id: text('invoice_item_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  batch_number_snapshot: text('batch_number_snapshot'),
  expiry_date_snapshot: text('expiry_date_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  instructions_snapshot: text('instructions_snapshot'),
  quantity_to_release: real('quantity_to_release'),
  quantity_released: real('quantity_released'),
  status: text('status'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
